import { useEffect } from "react";
import log from "../../../utils/logger/library";
import { turnOn, contentFactory, turnOff, turnOnError } from "./lib/readjs";

const InRead = (props) => {
    useEffect(() => {
        turnOn(
            contentFactory(
                props.url,
                props.type,
                props.id,
                props.headline,
                props.pubdate
            ),
            props.onRead
        ).catch(() => log.error("(InRead)", turnOnError));
        return () => turnOff();
    }, []);

    return props.children;
};

export default InRead;
